export const charLimit = 250;

export const textRectPadding = 5;

export const expandedTextRectWidth = 450;

export const trimmedTextRectWidth = 300;

// Label-mode (collapsed) sizing. Pulled out so the canvas reads more
// like a mind-map / Figma board than a column of long thin bars.
// Short labels (1–2 words) still get the min width so they have
// visual presence; multi-line labels wrap inside the max width.
export const labelRectMinWidth = 128;
export const labelRectMinHeight = 56;
export const labelRectMaxWidth = 220;
export const labelRectPadding = 12;
export const labelRectCornerRadius = 12;
/**
 * Vertical headroom reserved at the top of a collapsed rect that carries
 * a page-provenance badge. The badge chip (19px at y=4) lives in this
 * band; the label text renders below it, so tight label-fit sizing and
 * the badge can never collide. Applied wherever a collapsed size is
 * computed for a badge-bearing rect (creation + collapse toggle).
 */
export const pageBadgeHeadroom = 24;

export const canvasTextFontFamily = "Fira Code";

export const canvasTextFontSize = 16;

export const canvasTagFontFamily = "Fira Code";

export const canvasDarkText = "rgb(105, 100, 90)";
